// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test'
    //suggestionPosition: 'left'
  }
};

(function () { // Add this
  BoostPFS.inject(this); // Add this

  /* some code */
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function (suggestionElement, searchElement, searchBoxId) {};

  InstantSearch.prototype.beforeInit = function (id) {
    // Remove the default Instant Search of the theme
    jQ('.live-search-form, .site-header-search-form').removeAttr('data-live-search-form').removeAttr('data-live-search-flydown');
    jQ('input[name="q"]').removeAttr('data-live-search-input');
    jQ('.search-flydown').hide();
    jQ('button.site-header-search-button.button-primary').prop("type", "submit");
    jQ('button.live-search-button.button-primary').prop("type", "submit");
    jQ(document).ready(function () {
      jQ('.live-search-form, .site-header-search-form').off(".search-form");
      if (typeof bcHeaderSearch !== 'undefined') bcHeaderSearch.unload();
    });
  };

  InstantSearchResultItemProduct.prototype.compileTemplate = function () {
    if (this.isShow) {

      var searchTerm = Utils.stripHtml(Globals.currentTerm);

      // Product image
      var imageHTML = '';
      if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
        imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
        imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
      }

      // Product title
      var productTitle = this.customizeProductTitle();
      productTitle = this._highlightSuggestionResult(productTitle, searchTerm);

      // SKU
      var skuHTML = '';
      if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
        skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
        skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
      }

      // Vendor
      var vendorHTML = '';
      if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
        vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
        vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
      }

      console.log(this.data);
      const unit = this.data.metafields.find((o) => o.key === "unit");
      const packageAmount = this.data.metafields.find((o) => o.key === "inhoud_pak");
      const priceMin = this.data.price_min;
      const priceMax = this.data.price_max;
      const compareAtPriceMax = this.data.compare_at_price_max;

      // Price
      var priceHTML = this.compileSuggestionProductPrice();

      console.log(priceHTML);

      if (packageAmount != undefined && unit != undefined && priceMin != undefined && priceMax != undefined) {
        let pricePerUnit = ((priceMin != 0 ? priceMin : priceMax) / packageAmount.value).toFixed(2);
        let priceMaxPerUnit = (compareAtPriceMax / packageAmount.value).toFixed(2);

        // priceHTML = `
        // <div class="related-product--price">
        //     <div class="price__compare-at visible">
        //         <span class="money">€${parseFloat(priceMaxPerUnit).toFixed(2)}</span>
        //     </div>
        //     <div class="price__current">
        //         <span class="money">€${pricePerUnit}</span>
        //         <span class="unit-text">per ${unit.value}</span>
        //     </div>
        // </div>`;

        priceHTML = `
        <div class="boost-pfs-search-suggestion-product-price">
          <div class="boost-pfs-search-suggestion-product-sale-price">
            <span class="money">€${pricePerUnit}</span>
            <span class="unit-text">per ${unit.value}</span>
          </div>
          <s>€${parseFloat(priceMaxPerUnit).toFixed(2)}</s>
        </div>`;
        // priceHTML = priceHTML.replace(/<s>[\s\S]*?<\/s>/, `<s>€${priceMaxPerUnit}</s>`);
        // priceHTML = priceHTML.replace(/product-sale-price">[\s\S]*?<\/span>/, `product-sale-price"><div class="price-text"><span class="money">€${pricePerUnit}</span> <span class="unit-text"> per ${unit.value}</span></div></span>`);
        // console.log('newpricehtml', priceHTML);
      }


      // Open the result item in new tab when selected
      var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

      // Found variant based on search term
      var itemUrl = this.url.split('?variant')[0];


      if (this.data.hasOwnProperty('skus')) {
        var variantSKU = this.data.skus.filter(function (skuValue) {
          return skuValue.toLowerCase() == searchTerm.toLowerCase();
        })

        // Found variant ID based on the sku
        var variantID = this.data.variants.filter(function (varID) {
          if (varID.sku === variantSKU[0]) return varID.id;
        })

        if (typeof variantSKU[0] !== 'undefined' && typeof variantID[0] !== 'undefined') itemUrl += '?variant=' + variantID[0]['id'];
      }


      return this.getTemplate()
        .replace(/{{id}}/g, this.id)
        .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
        .replace(/{{url}}/g, itemUrl)
        .replace(/{{newTabAttribute}}/g, newTabAttr)
        .replace(/{{itemProductImage}}/g, imageHTML)
        .replace(/{{title}}/g, productTitle)
        .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
        .replace(/{{itemProductSku}}/g, skuHTML)
        .replace(/{{itemProductVendor}}/g, vendorHTML)
        .replace(/{{itemProductPrice}}/, priceHTML)
        .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
        .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
        .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem)
    } else {
      return '';
    }
  }

})();